export default __webpack_public_path__ + "2720ffa4fd5be073ac05a0dea29a925b.svg";